<template>
  <section class="platform-editor-access" role="status">
    <i v-if="!error" class="el-icon-loading" aria-hidden="true"></i>
    <p>{{ error || '正在接入平台登录信息…' }}</p>
  </section>
</template>
<script>
import store from '@/store'
import { platformEditorTarget, platformEditorOrigin } from '@/runtime/platform-editor-access'
export default {
  data: () => ({ error: '' }),
  mounted() {
    let origin, target
    try {
      origin = platformEditorOrigin(this.$route.query.parentOrigin)
      target = platformEditorTarget(this.$route.params.target, this.$route.params.id)
    } catch (e) {
      this.error = e.message
      return
    }
    const opener = window.opener
    if (!opener || opener === window) {
      this.error = '请从主平台管理页面打开'
      return
    }
    const nonce = Array.from(window.crypto.getRandomValues(new Uint32Array(4)))
      .map((value) => value.toString(16))
      .join('-')
    this.receiver = async (event) => {
      if (
        event.source !== opener ||
        event.origin !== origin ||
        event.data?.type !== 'visualization-editor-login' ||
        event.data.nonce !== nonce ||
        typeof event.data.token !== 'string' ||
        !event.data.token
      )
        return
      window.removeEventListener('message', this.receiver)
      clearTimeout(this.timer)
      try {
        await store.dispatch('auth/clearPermissions')
        await store.dispatch('user/logout')
        if (this._isDestroyed) return
        localStorage.setItem('x-access-token', event.data.token)
        // 登录交接后断开opener，编辑器沿用正常路由鉴权和资源权限。
        window.opener = null
        await this.$router.replace(target)
      } catch (e) {
        if (!this._isDestroyed) this.error = e.message || '编辑器接入失败'
      }
    }
    this.timer = setTimeout(() => {
      window.removeEventListener('message', this.receiver)
      this.error = '平台登录接入超时，请关闭并重新打开'
    }, 20000)
    window.addEventListener('message', this.receiver)
    opener.postMessage({ type: 'visualization-editor-ready', nonce }, origin)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.receiver)
    clearTimeout(this.timer)
  }
}
</script>
<style scoped>
.platform-editor-access {
  min-height: 100vh;
  display: grid;
  align-content: center;
  justify-items: center;
  padding: 24px;
  box-sizing: border-box;
  color: #475467;
  background: #f5f7fa;
}
.platform-editor-access i {
  font-size: 28px;
  color: #1677ff;
}
</style>
